var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.0013V16.668C15.8333 17.11 15.6577 17.5339 15.3451 17.8465C15.0326 18.159 14.6087 18.3346 14.1666 18.3346H5.83329C5.39127 18.3346 4.96734 18.159 4.65478 17.8465C4.34222 17.5339 4.16663 17.11 4.16663 16.668V5.0013M6.66663 5.0013V3.33464C6.66663 2.89261 6.84222 2.46868 7.15478 2.15612C7.46734 1.84356 7.89127 1.66797 8.33329 1.66797H11.6666C12.1087 1.66797 12.5326 1.84356 12.8451 2.15612C13.1577 2.46868 13.3333 2.89261 13.3333 3.33464V5.0013",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "#293755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.16797V14.168",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3426ae0f45d8452cb262936e7bde003a.svg";
export { ForwardRef as ReactComponent };